<section class="map-section">
  <div class="map-header">
    <p class="map-label">Find Us</p>
  </div>

  <div class="map-layout">
    <div id="map"></div>
    <div class="location-list-wrapper">
      <h2>Our Locations</h2>
      <div class="location-list">
        @for (loc of locations; track loc; let i = $index) {
          <div
            class="location-card"
            [class.active]="selectedIndex === i"
            (click)="selectLocation(i)"
            >
            <div class="location-marker">
              <img [src]="branding.logoUrl()" alt="McDonald's" />
            </div>
            <div class="location-info">
              <strong>{{ loc.name }}</strong>
              <span>{{ loc.address }}</span>
              <span class="location-hours">{{ loc.hours }}</span>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
</section>
